import { useState } from "react";
import { useMotionValue, Reorder } from "framer-motion";
import { useRaisedShadow } from "./use-raised-shadow.tsx";
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
export const Item = ({ item, removeTheOneField, setlabelCol, settypeCol, setoptionsCol, setisRequiredCol }) => {
  const y = useMotionValue(0);
  const boxShadow = useRaisedShadow(y);

  const [isChecked, setIsChecked] = useState(true)
  const [selectedOption, setSelectedOption] = useState({ value: 'Text', label: 'Text' })

  const [isDistict, setIsDistinct] = useState(false)

  const addSubField = (id) => {
    const getAllField = document.getElementsByClassName(`${item}_insider`);
    const lastFleid = getAllField[getAllField.length - 1];

    if (!getAllField.length || lastFleid.value.length > 0) {

      const frame = document.getElementById(id);
      const containers = document.createElement("div");

      containers.classList.add("d-flex", "gap-3", "align-items-center")

      const crossIcon = document.createElement("i");

      crossIcon.classList.add('fa', 'fa-times', 'text-danger')
      crossIcon.id = `${id}_close_${getAllField.length}`
      crossIcon.style.cursor = "pointer"
      crossIcon.addEventListener("click", (e) => {
        if (document.getElementsByClassName(`${item}_insider`).length > 1) {
          frame.removeChild(containers)
        }
        else {
          console.log("only left")
        }
      })

      const newOption = document.createElement("input");
      newOption.type = "text"
      newOption.id = id + "_input_" + getAllField.length
      newOption.placeholder = "Option"
      newOption.required = true
      newOption.classList.add("form-control", "dataFieldOption")
      newOption.classList.add(`${item}_insider`)


      containers.appendChild(newOption)
      containers.appendChild(crossIcon)

      frame.appendChild(containers)
    } else {
      lastFleid.focus()
    }
  }

  return (
    <Reorder.Item value={item} id={item} style={{ boxShadow, y }}>
      <div className="d-flex flex-column gap-3 w-100">
        <div className="d-flex gap-2 w-100">
          <input type="text" id={`${item}_dataFieldLabel`} required placeholder="Label" className="form-control dataFieldLabel w-100"/>
          <Select
            id={`${item}_type_selector`}
            value={selectedOption}
            onChange={setSelectedOption}
            className="customSelector dataFieldType"
            options={[
              { value: 'Text', label: 'Text' },
              { value: 'Phone', label: 'Phone' },
              { value: 'Number', label: 'Number' },
              { value: 'Email', label: 'Email' },
              { value: 'Select', label: 'Select' },
              { value: 'Textarea', label: 'Textarea' },
              { value: 'Reset', label: 'Reset' },
              { value: 'Submit', label: 'Submit' },
              { value: 'Date', label: 'Date' },
              { value: 'File', label: 'File' },
            ]}
          />
        </div>
        <div className="d-flex flex-column gap-3">
          {
            selectedOption.value === "Text" ?
              <input type="text" placeholder="Enter your value" className="form-control dataFieldOption" id={`${item}_insider_input`} />
              :
              selectedOption.value === "Email" ?
                <input type="email" placeholder="Enter your value" className="form-control dataFieldOption" id={`${item}_insider_input`} />
                :
                selectedOption.value === "Phone" ?
                  <input type="tel" placeholder="Enter your value" className="form-control dataFieldOption" id={`${item}_insider_input`} />
                  :
                  selectedOption.value === "Number" ?
                    <input type="number" placeholder="Enter your value" className="form-control dataFieldOption" id={`${item}_insider_input`} />
                    :
                    selectedOption.value === "Select" ?
                      <div className="d-flex flex-column gap-2">
                        <div id={`${item}_insider`} className="w-100 d-flex flex-column gap-2">
                          <div className="d-flex gap-3 align-items-center" id={`${item}_container`}>
                            <input type="text" id={`${item}_insider_input_0`} className={`form-control ${item}_insider dataFieldOption`} placeholder="Option" />
                            <i className="fa fa-times text-danger" style={{ cursor: "pointer" }} onClick={(e) => { if (document.getElementsByClassName(`${item}_insider`).length > 1) { document.getElementById(`${item}_insider`).removeChild(document.getElementById(`${item}_container`)) } else { console.log("only left") } }}></i>
                          </div>
                        </div>
                        <span className="fs-6 rouded alert alert-muted p-0 d-flex gap-1 align-items-center" onClick={(e) => { addSubField(`${item}_insider`) }} style={{ cursor: "pointer", color: "rgba(0,0,0,0.3)" }}>
                          <i className="fa fa-plus"></i>add new option</span>
                      </div>
                      :
                      selectedOption.value === "Textarea" ?
                        <textarea name="" id={`${item}_insider_input`} className="form-control dataFieldOption"></textarea>
                        :
                        selectedOption.value === "Reset" ?
                          <button type="reset" className="btn btn-sm btn-secondary">Reset</button>
                          :
                          selectedOption.value === "Submit" ?
                            <button type="button" className="btn btn-sm btn-success">Submit</button>
                            :
                            selectedOption.value === "File" ?
                              <input type="file" id={`${item}_insider_input`} className="form-control dataFieldOption" />
                              :
                              selectedOption.value === "Date" ?
                                <input type="date" id={`${item}_insider_input`} className="form-control dataFieldOption" />
                                :
                                ""
          }

        </div>
        <div className="d-flex align-items-center justify-content-end gap-3 flex-wrap">

          <Form.Check // prettier-ignore
            type="switch"
            id={`${item}_distinct`}
            label="Distinct"
            className={`fs-6 dataFieldDistinct ${selectedOption.value !== "Submit" && selectedOption.value !== "Reset" ? "" : "d-none"}`}
            reverse
            checked={isDistict}
            value={isDistict}
            onChange={() => { setIsDistinct(!isDistict) }}
          />
          <Form.Check // prettier-ignore
            type="switch"
            id={`${item}_required`}
            label="Required"
            className={`fs-6 dataFieldRequirement ${selectedOption.value !== "Submit" && selectedOption.value !== "Reset" ? "" : "d-none"}`}
            reverse
            checked={isChecked}
            value={isChecked}
            onChange={() => { setIsChecked(!isChecked) }}
          />
          <i className="fa fa-trash fs-6" title="Delete this field." style={{ cursor: "pointer" }} onClick={(e) => {
            removeTheOneField(item)
          }}></i>
        </div>
      </div>
    </Reorder.Item >
  );
};
